import { Grid } from "@mui/material";
import * as React from "react";
import { Create, required, TextInput } from "react-admin";
import { SimpleForm } from "src/enterprise/ra-rbac";
import { PriceCalculatorCreateComponent } from "./PriceCalculatorComponent";
import { PriceCalculatorInput } from "src/components/input";

export const PriceCalculatorCreate = () => (
  <Create component={PriceCalculatorCreateComponent}>
    <SimpleForm>
      <Grid container rowSpacing={1} columnSpacing={2}>
        <Grid item sm={12}>
          <TextInput source="name" validate={required()} />
        </Grid>
        <Grid item sm={12}>
          <PriceCalculatorInput source="rules" required base64 fullWidth validate={required()}/>
        </Grid>
      </Grid>
    </SimpleForm>
  </Create>
);
